import { h } from 'preact';
import style from "./style.css";
import cx from 'classnames';

const OurBusiness = () => (
    <div className={cx(style.ourBusines, 'flex', 'items-center', 'flex-col')}>
        <div className={cx('flex')}><img src={'/assets/ourBusiness/ourBusinessIcon.png'}/></div>
        <div className={cx('flex', 'subTitleText')}>OUR BUSINESS</div>
        <div className={cx('flex')}>Player Index (PI Technology Holdings Limited) is a joint venture (JV) between PI Software Holdings Limited and Think IT Solutions (Mindera).
Player Index is licensed and regulated by the UK Gambling Commission under Think IT Solution’s licence No: 000-012345-N-987654-001</div>
    </div>
);

export default OurBusiness;


// WEBPACK FOOTER //
// ./components/OurBusiness/index.jsx